// noinspection JSUnusedGlobalSymbols
// Courtesy of https://stackoverflow.com/q/21054126/862825
export default (): boolean => !matchMedia('(hover:hover)').matches || !matchMedia('(pointer:fine)').matches
